(function () {
  'use strict';
  // Shopify replaces the cart drawer via section rendering. Scripts embedded in the
  // returned HTML are not guaranteed to run, so initialize delivery centrally.
  if (window.__zaltifyCartDeliveryInitialized) return;
  window.__zaltifyCartDeliveryInitialized = true;

  var selector = '.cart-drawer .zc-buybox[data-cart-context="true"]';
  var refreshQueued = false;

  function localNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Copenhagen',
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    function n(key) {
      var part = parts.find(function (item) { return item.type === key; });
      return part ? parseInt(part.value, 10) : 0;
    }
    return { year:n('year'), month:n('month'), day:n('day'),
      hour:n('hour'), minute:n('minute'), second:n('second') };
  }

  function dayFromParts(p) {
    return new Date(Date.UTC(p.year, p.month - 1, p.day, 12));
  }

  function isBusinessDay(day) {
    var weekday = day.getUTCDay();
    return weekday >= 1 && weekday <= 5;
  }

  function nextBusinessDay(day) {
    var next = new Date(day);
    do { next.setUTCDate(next.getUTCDate() + 1); } while (!isBusinessDay(next));
    return next;
  }

  function estimateDelivery(p, days) {
    var dispatch = dayFromParts(p);
    if (!isBusinessDay(dispatch) || p.hour >= 14) {
      dispatch = nextBusinessDay(dispatch);
    }
    var eta = new Date(dispatch);
    for (var i = 0; i < days; i++) eta = nextBusinessDay(eta);
    return eta;
  }

  function updateBox(box, p) {
    var days = parseInt(box.getAttribute('data-days'), 10);
    var dateNode = box.querySelector('.zc-buybox__date');
    if (dateNode && Number.isFinite(days) && days > 0) {
      try {
        var formatted = estimateDelivery(p, days).toLocaleDateString(
          box.getAttribute('data-locale') || 'en',
          {weekday:'long',day:'numeric',month:'long',timeZone:'UTC'}
        );
        var label = box.getAttribute('data-delivery-label') || 'estimated delivery';
        var fullText = ' - ' + label + ': ' + formatted;
        if (dateNode.textContent !== fullText) dateNode.textContent = fullText;
      } catch (error) {
        // Localized pending or checkout text from Liquid stays visible.
        if (!box.__zcDeliveryErrorLogged) {
          console.warn('[Zaltify cart delivery] Could not format date', error);
          box.__zcDeliveryErrorLogged = true;
        }
      }
    }

    var row = box.querySelector('.zc-buybox__countdown');
    var line = box.querySelector('.zc-buybox__cd');
    if (!row || !line || row.style.display === 'none') return;
    if (typeof box.__zcOriginalCountdownHTML !== 'string') {
      box.__zcOriginalCountdownHTML = line.innerHTML;
    }

    var day = dayFromParts(p);
    var timeLeft = 14 * 3600 - (p.hour * 3600 + p.minute * 60 + p.second);
    var workingDay = isBusinessDay(day);

    if (workingDay && timeLeft > 0) {
      var h = Math.floor(timeLeft / 3600);
      var m = Math.floor(timeLeft % 3600 / 60);
      var s = timeLeft % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var formattedTime = pad(h) + ':' + pad(m) + ':' + pad(s);
      // Rebuild a missing timer. Other product sections must never leave a
      // stale "--:--:--" placeholder visible in the cart.
      var counter = line.querySelector('.zc-buybox__timer');
      if (!counter) {
        var prefix = row.getAttribute('data-today-pre') || '';
        var suffix = row.getAttribute('data-today-post') || '';
        line.textContent = prefix + ' ' + formattedTime + suffix;
      } else if (counter.textContent !== formattedTime) {
        counter.textContent = formattedTime;
      }
      box.__zcCountdownMode = 'live';
    } else {
      var following = nextBusinessDay(day);
      var tomorrow = new Date(day);
      tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
      var mode = following.getTime() === tomorrow.getTime() ? 'tomorrow' : 'monday';
      var message = row.getAttribute('data-' + mode) ||
        row.getAttribute('data-tomorrow') || '';
      // Compare actual text, not just a cached mode: a competing section render
      // can replace the line without clearing custom element properties.
      if (line.textContent !== message) line.textContent = message;
      box.__zcCountdownMode = mode;
    }
    if (row.hidden) row.hidden = false;
  }

  function refresh() {
    var boxes = document.querySelectorAll(selector);
    if (!boxes.length) return;
    try {
      var parts = localNow();
      boxes.forEach(function (box) { updateBox(box, parts); });
    } catch (error) {
      console.warn('[Zaltify cart delivery] Unable to update delivery information', error);
    }
  }

  function scheduleRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    Promise.resolve().then(function () {
      refreshQueued = false;
      refresh();
    });
  }

  function hasCartBox(node) {
    return node.nodeType === 1 &&
      ((node.matches && node.matches(selector)) ||
      (node.querySelector && node.querySelector(selector)));
  }

  function start() {
    refresh();
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasCartBox(added[j])) { scheduleRefresh(); return; }
        }
      }
    });
    observer.observe(document.body, {childList:true,subtree:true});
    document.addEventListener('cart:update', scheduleRefresh);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh();
    });
    // One timer for all cart redraws: updates delivery on the next Copenhagen
    // calendar day and correctly rolls the 14:00 cutoff without page refresh.
    setInterval(refresh, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once:true});
  } else {
    start();
  }
})();
